import { Button, ButtonGroup, Col, Dropdown, DropdownButton, Form, InputGroup, Row } from "react-bootstrap";
import { TIME_SCALE_MAP, getAbsoluteTimeFromRelativeTime, getDateStrFromDate, getLocalizedDate, getTimeStrFromDate } from '../../utils/time';
import { DateScale, DateType } from './dateTypes';

/**
 * Selector for the date range
 */
export const MetricsDateSelector = ({
    filterDateOptions,
    setFilterDateOptions,
}: any) => {
    const applyTime = (key: string, val: any) => {
        if (key === "dateOptionType" && val === DateType.Relative) {
            const updatedStartTime = getAbsoluteTimeFromRelativeTime(filterDateOptions["relativeStart"] + filterDateOptions["relativeStartScale"]);
            const updatedEndTime = getAbsoluteTimeFromRelativeTime(filterDateOptions["relativeEnd"] + filterDateOptions["relativeEndScale"]);
            setFilterDateOptions({
                ...filterDateOptions,
                absoluteStart: updatedStartTime,
                absoluteEnd: updatedEndTime,
                [key]: val,
            })
        } else {
            setFilterDateOptions({
                ...filterDateOptions,
                [key]: val,
            });
        }
    };

    const handleRelativeStartChange = (event: any) => {
        const updatedStartTime = getAbsoluteTimeFromRelativeTime(event.target.value + filterDateOptions["relativeStartScale"]);
        if (!isNaN(updatedStartTime.getTime())) {
            setFilterDateOptions({
                ...filterDateOptions,
                relativeStart: event.target.value,
                absoluteStart: updatedStartTime,
            })
        }
    };

    const handleRelativeStartUnitChange = (k: any) => {
        const updatedStartTime = getAbsoluteTimeFromRelativeTime(filterDateOptions["relativeStart"] + k);
        if (!isNaN(updatedStartTime.getTime())) {
            setFilterDateOptions({
                ...filterDateOptions,
                relativeStartScale: k,
                absoluteStart: updatedStartTime,
            })
        }
    };

    const handleRelativeEndChange = (event: any) => {
        const updatedEndTime = getAbsoluteTimeFromRelativeTime(event.target.value + filterDateOptions["relativeEndScale"]);
        if (!isNaN(updatedEndTime.getTime())) {
            setFilterDateOptions({
                ...filterDateOptions,
                relativeEnd: event.target.value,
                absoluteEnd: updatedEndTime,
            })
        }
    };

    const handleRelativeEndUnitChange = (k: any) => {
        const updatedEndTime = getAbsoluteTimeFromRelativeTime(filterDateOptions["relativeEnd"] + k);
        if (!isNaN(updatedEndTime.getTime())) {
            setFilterDateOptions({
                ...filterDateOptions,
                relativeEndScale: k,
                absoluteEnd: updatedEndTime,
            })
        }
    }

    const handleShortcut = (shortcut: string) => {
        if (shortcut === "1w") {
            setFilterDateOptions({
                ...filterDateOptions,
                dateOptionType: DateType.Relative,
                relativeStart: 7,
                relativeStartScale: "d",
                relativeEnd: 0,
                relativeEndScale: "d",
                absoluteStart: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7),
                absoluteEnd: new Date(),
            })
        } else if (shortcut === "30d") {
            setFilterDateOptions({
                ...filterDateOptions,
                dateOptionType: DateType.Relative,
                relativeStart: 30,
                relativeStartScale: "d",
                relativeEnd: 0,
                relativeEndScale: "d",
                absoluteStart: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30),
                absoluteEnd: new Date(),
            })
        } else if (shortcut === "90d") {
            setFilterDateOptions({
                ...filterDateOptions,
                dateOptionType: DateType.Relative,
                relativeStart: 90,
                relativeStartScale: "d",
                relativeEnd: 0,
                relativeEndScale: "d",
                absoluteStart: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 90),
                absoluteEnd: new Date(),
            })
        } else if (shortcut === "1y") {
            setFilterDateOptions({
                ...filterDateOptions,
                dateOptionType: DateType.Relative,
                relativeStart: 365,
                relativeStartScale: "d",
                relativeEnd: 0,
                relativeEndScale: "d",
                absoluteStart: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 365),
                absoluteEnd: new Date(),
            })
        } else {
            setFilterDateOptions({
                ...filterDateOptions,
                dateOptionType: DateType.Relative,
                relativeStart: null,
                relativeStartScale: "d",
                relativeEnd: 0,
                relativeEndScale: "d",
                absoluteStart: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 365),
                absoluteEnd: new Date(),
            })
        }
    }

    return (
        <>
            <ButtonGroup size="sm" className="d-flex mb-2">
                <Button size="sm" variant={(filterDateOptions.dateOptionType === DateType.Relative) ? "secondary" : "outline-secondary"} onClick={() => {applyTime("dateOptionType", DateType.Relative)}}>Relative</Button>
                <Button size="sm" variant={(filterDateOptions.dateOptionType === DateType.Absolute) ? "secondary" : "outline-secondary"} onClick={() => {applyTime("dateOptionType", DateType.Absolute)}}>Absolute</Button>
            </ButtonGroup>

            {
                filterDateOptions["dateOptionType"] === DateType.Relative && (
                    <ButtonGroup size="sm" className="d-flex mb-2">
                        <Button size="sm" variant={(filterDateOptions.dateOptionType === DateType.Relative && filterDateOptions.relativeStart === 7 && filterDateOptions.relativeEnd === 0 && filterDateOptions.relativeStartScale === DateScale.Day) ? "secondary" : "outline-secondary"} onClick={() => handleShortcut("1w")}>1w</Button>
                        <Button size="sm" variant={(filterDateOptions.dateOptionType === DateType.Relative && filterDateOptions.relativeStart === 30 && filterDateOptions.relativeEnd === 0 && filterDateOptions.relativeStartScale === DateScale.Day) ? "secondary" : "outline-secondary"} onClick={() => handleShortcut("30d")}>30d</Button>
                        <Button size="sm" variant={(filterDateOptions.dateOptionType === DateType.Relative && filterDateOptions.relativeStart === 90 && filterDateOptions.relativeEnd === 0 && filterDateOptions.relativeStartScale === DateScale.Day) ? "secondary" : "outline-secondary"} onClick={() => handleShortcut("90d")}>90d</Button>
                        <Button size="sm" variant={(filterDateOptions.dateOptionType === DateType.Relative && filterDateOptions.relativeStart === 365 && filterDateOptions.relativeEnd === 0 && filterDateOptions.relativeStartScale === DateScale.Day) ? "secondary" : "outline-secondary"} onClick={() => handleShortcut("1y")}>1y</Button>
                    </ButtonGroup>
                )
            }
            {
                filterDateOptions["dateOptionType"] === DateType.Absolute ? (
                    <>
                        <Row>
                            <Col>
                                <div className="metrics-control-subtitle">Start</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Control type="date" name='startDate' value={getDateStrFromDate(filterDateOptions["absoluteStart"])} onChange={(event: any) => {applyTime("absoluteStart", getLocalizedDate(event.target.value, getTimeStrFromDate(filterDateOptions["absoluteStart"])))}} />
                            </Col>
                            <Col>
                                <Form.Control type="time" name='startTime' value={getTimeStrFromDate(filterDateOptions["absoluteStart"])} onChange={(event: any) => {applyTime("absoluteStart", getLocalizedDate(getDateStrFromDate(filterDateOptions["absoluteStart"]), event.target.value))}} />
                            </Col>
                        </Row>
                        <Row className='mt-1'>
                            <Col>
                                <div className="metrics-control-subtitle">End</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Control type="date" name='endDate' value={getDateStrFromDate(filterDateOptions["absoluteEnd"])} onChange={(event: any) => {applyTime("absoluteEnd", getLocalizedDate(event.target.value, getTimeStrFromDate(filterDateOptions["absoluteEnd"])))}} />
                            </Col>
                            <Col>
                                <Form.Control type="time" name='endTime' value={getTimeStrFromDate(filterDateOptions["absoluteEnd"])} onChange={(event: any) => {applyTime("absoluteEnd", getLocalizedDate(getDateStrFromDate(filterDateOptions["absoluteEnd"]), event.target.value))}} />
                            </Col>
                        </Row>
                    </>
                ) : (
                    <>
                        <Row>
                            <Col>
                                <div className="metrics-control-subtitle">Start</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <InputGroup>
                                    <Form.Control type="number" aria-label="Start" value={filterDateOptions["relativeStart"]} onChange={(event: any) => {handleRelativeStartChange(event)}} />

                                    <DropdownButton
                                        variant="outline-secondary"
                                        title={TIME_SCALE_MAP[filterDateOptions["relativeStartScale"]]}
                                        align="end"
                                    >
                                        {
                                            Object.keys(TIME_SCALE_MAP).map((k: any) => {
                                                return (
                                                    <Dropdown.Item key={k} onClick={() => handleRelativeStartUnitChange(k)}>{TIME_SCALE_MAP[k]}</Dropdown.Item>
                                                )
                                            })
                                        }
                                    </DropdownButton>
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col>
                                <div className="metrics-control-subtitle">End</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <InputGroup>
                                    <Form.Control type="number" aria-label="End" value={filterDateOptions["relativeEnd"]} onChange={(event: any) => {handleRelativeEndChange(event)}} />

                                    <DropdownButton
                                        variant="outline-secondary"
                                        title={TIME_SCALE_MAP[filterDateOptions["relativeEndScale"]]}
                                        align="end"
                                    >
                                        {
                                            Object.keys(TIME_SCALE_MAP).map((k: any) => {
                                                return (
                                                    <Dropdown.Item key={k} onClick={() => {handleRelativeEndUnitChange(k)}}>{TIME_SCALE_MAP[k]}</Dropdown.Item>
                                                )
                                            })
                                        }
                                    </DropdownButton>
                                </InputGroup>
                            </Col>
                        </Row>
                    </>
                )
            }
        </>
    );
};

